import { useQuery } from '@tanstack/react-query'
import { listPlanAndRateOverrideRules } from '../../../../../api/plan-and-rate-override-rules-api'
import type { ListPlanAndRateOverrideRulesQueryDto } from '../../../../../api/dto/plan-and-rate-override-rules.dto'

export const PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY =
  'plan-and-rate-override-rules'

export function useGetPlanAndRateOverrideRules(
  params: ListPlanAndRateOverrideRulesQueryDto,
  options?: { enabled?: boolean }
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY, params],
    queryFn: () => listPlanAndRateOverrideRules(params),
    staleTime: 30_000,
    enabled: options?.enabled ?? true,
  })

  return {
    items: data?.data ?? [],
    total: data?.meta.total ?? 0,
    page: data?.meta.page ?? 1,
    limit: data?.meta.limit ?? 20,
    totalPages: data?.meta.totalPages ?? 0,
    isLoading,
    error,
  }
}
